import { ValueFunction } from '../../index';

function multiplyMethod({a = null, b = null}) {
  if (a !== null && b !== null) {
    return a * b;
  } else {
    return null;
  }
}

export const multiply = new ValueFunction(
  multiplyMethod,
  {
    label: 'Multiply Two Series',
    description: 'a * b',
    parameters: [
      {'name': 'a', 'type': 'number'},
      {'name': 'b', 'type': 'number'},
    ],
    maxLength: 2
  }
);